'use strict';

wbApp.directive('wbStudentLookup', ['$http', '$translate', '$timeout', '$filter', 'notificationSvc',
    function ($http, $translate, $timeout, $filter, notificationSvc) {

        function getFullName(name, middleName, surName) {
            var fullName = name;
            if (!!middleName) {
                if (!!fullName) {
                    fullName = fullName + " " + middleName;
                }
                else {
                    fullName = middleName;
                }
            }

            if (!!surName) {
                if (!!fullName)
                    fullName = fullName + " " + surName;
                else
                    fullName = surName;
            }

            return fullName;
        }

        function formatResult(student) {
            if (!student) { return; }

            var birthday = !student.birthday
                ? ""
                : $filter('date')(student.birthday, 'shortDate');

            var parentFullName = !!student.user ? getFullName(student.user.name, student.user.middlename, student.user.surname) : '';
            var email = !!student.user ? student.user.email : '';

            return "<div class='row'>" +
                        "<div class='col-md-3'>" + getFullName(student.name, student.middlename, student.surname) + "</div>" +
                        "<div class='col-md-3'>" + parentFullName + "</div>" +
                        "<div class='col-md-2'>" + birthday + "</div>" +
                        "<div class='col-md-4'>" + email + "</div>" +
                    "</div>";
        }

        function formatSelection(student) {
            return getFullName(student.name, student.middlename, student.surname);
        }

        function dateParse(strDate) {
            if (Window['moment'])
                return moment(strDate).toDate();
            return Date.parse(strDate);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '=',
                userIdFilter: '=',
                parentId: '=',
                contactPhone: '=',
                contactEmail: '=',
                parentFullName: '=',
                health: '='
            },
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_STUDENT'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: !attrs.required,
                        query: function (query) {
                            if (!!attrs.userIdFilter && !!scope.userIdFilter) {
                                
                                $http({
                                    method: 'GET',
                                    url: "restapi/students/find-by-user-id",
                                    params: {
                                        userId: scope.userIdFilter,
                                        expanded: 'User',
                                    }
                                }).success(function (data, status, headers, config) {

                                    var filteredData = !!query.term
                                        ? _.filter(data, function (item) {
                                            var fullName = getFullName(item.name, item.middlename, item.surname);
                                            return fullName.toLocaleUpperCase().includes(query.term.toLocaleUpperCase());
                                        })
                                        : data;

                                    var skip = Math.max(10 * (query.page - 1), 0);
                                    var take = 10 * query.page;

                                    var paged = _.take(_.drop(filteredData, skip), take);
                                    query.callback({ results: paged, more: paged.length >= 10 });
                                }).error(function (errorResult, status, headers, config) {
                                    query.callback({ results: [], more: false });
                                });
                            } else {
                                $http({
                                    method: 'GET',
                                    url: "restapi/students/paged/find-by-name",
                                    params: {
                                        nameSubstring: query.term,
                                        take: 10,
                                        skip: Math.max(10 * (query.page - 1), 0),
                                        expanded: 'User'
                                    }
                                }).success(function (data, status, headers, config) {
                                    query.callback({ results: data, more: data.length >= 10 });
                                }).error(function (errorResult, status, headers, config) {
                                    query.callback({ results: [], more: false });
                                });                                
                            }                            
                        },
                        initSelection: function (element, callback) {
                            var id = $(element).val();
                            if (id != 0) {
                                $http({
                                    method: 'GET',
                                    url: "restapi/students/" + id,
                                    params: {
                                        expanded: 'User'
                                    }
                                })
                                .success(function (data, status, headers, config) {
                                    controller.$setViewValue(data.id);
                                    if (!!attrs.userIdFilter) {
                                        scope.userIdFilter = data.userID;
                                    }
                                    if (typeof scope.parentId !== 'undefined') {
                                        scope.parentId = data.userID;
                                    }
                                    if (typeof scope.contactPhone !== 'undefined') {
                                        if (!!data.user) {
                                            scope.contactPhone = data.user.phone;
                                        } else {
                                            scope.contactPhone = null;
                                        }
                                    }
                                    if (typeof scope.contactEmail !== 'undefined') {
                                        if (!!data.user) {
                                            scope.contactEmail = data.user.email;
                                        } else {
                                            scope.contactEmail = null;
                                        }
                                    }
                                    if (typeof scope.parentFullName !== 'undefined') {
                                        if (!!data.user) {
                                            scope.parentFullName = getFullName(data.user.name, data.user.middlename, data.user.surname);
                                        } else {
                                            scope.parentFullName = null;
                                        }
                                    }
                                    if (typeof scope.health !== 'undefined') {
                                        scope.health = data.health || null;
                                    }                                    
                                    callback(data);
                                })
                                .error(function (errorResult, status, headers, config) {
                                    notificationSvc.notifyError(
                                       $translate.instant('TXT_ALERT_ERROR_READING_DATA'),
                                       notificationSvc.translateError(errorResult));
                                    callback(null);
                                });
                            } else {
                                controller.$setViewValue(null);
                                callback(null);
                            }
                        }
                    });


                    $(elm).on('select2-selecting', function (e) {
                        if (e.choice) {
                            scope.$apply(function () {
                                if (!!attrs.userIdFilter) {
                                    scope.userIdFilter = e.choice.userID;
                                }
                                if (typeof scope.parentId !== 'undefined') {
                                    scope.parentId = e.choice.userID;
                                }
                                if (typeof scope.contactPhone !== 'undefined') {
                                    if (!!e.choice.user) {
                                        scope.contactPhone = e.choice.user.phone;
                                    } else {
                                        scope.contactPhone = null;
                                    }
                                }
                                if (typeof scope.contactEmail !== 'undefined') {
                                    if (!!e.choice.user) {
                                        scope.contactEmail = e.choice.user.email;
                                    } else {
                                        scope.contactEmail = null;
                                    }
                                }
                                if (typeof scope.parentFullName !== 'undefined') {
                                    if (!!e.choice.user) {
                                        scope.parentFullName = getFullName(e.choice.user.name, e.choice.user.middlename, e.choice.user.surname);
                                    } else {
                                        scope.parentFullName = null;
                                    }
                                }
                                if (typeof scope.health !== 'undefined') {
                                    scope.health = e.choice.health || null;
                                }
                            });
                        }
                    });

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return null;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    if (!!attrs.userIdFilter) {
                        scope.$watch('userIdFilter', function (newValue, oldValue) {
                            if (newValue != oldValue && !!oldValue) {
                                elm.select2('val', null);
                            }
                        });
                    }

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                }, 1);

            }
        }
}]);
